module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._h('nav', {
    staticClass: "navbar navbar-fixed-top navbar-home"
  }, [_vm._h('div', {
    staticClass: "container"
  }, [_vm._h('button', {
    staticClass: "navbar-toggler hidden-sm-up",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#exCollapsingNavbar2",
      "aria-controls": "exCollapsingNavbar2",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, ["\n          ☰\n          "]), " ", _vm._h('div', {
    staticClass: "collapse navbar-toggleable-xs",
    attrs: {
      "id": "exCollapsingNavbar2"
    }
  }, [_vm._h('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_vm._h('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  })]), " ", _vm._h('ul', {
    staticClass: "nav navbar-nav float-xs-right"
  }, [_vm._h('li', {
    staticClass: "nav-item"
  }, [_vm._h('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/registro"
    }
  }, ["REGISTRO"])]), " ", _vm._m(0), " ", _vm._m(1)])])])]), " ", _vm._h('div', {
    staticClass: "wpo-view"
  }, [_vm._h('router-view')]), " ", _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('li', {
    staticClass: "nav-item"
  }, [_vm._h('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#"
    }
  }, ["ACCEDER"])])
},function (){var _vm=this;
  return _vm._h('li', {
    staticClass: "nav-item"
  }, [_vm._h('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#blog"
    }
  }, ["BLOG"]), " "])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col-md-8 offset-md-2",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._h('div', {
    staticClass: "redesSociales"
  }, [_vm._h('a', {
    attrs: {
      "href": "www.facebook.com",
      "target": "_blank"
    }
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/home/icFb.png",
      "alt": "Facebook"
    }
  })]), " ", _vm._h('a', {
    attrs: {
      "href": "www.twitter.com",
      "target": "_blank"
    }
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/home/icTw.png",
      "alt": "Twitter"
    }
  })])]), " ", _vm._h('p', {
    staticClass: "copyright"
  }, ["Copyright ", _vm._h('b', ["©"]), " 2016 WPO."])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ca36648!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 66
// module chunks = 1